<template>
    <v-app>
        <v-toolbar app>
            <router-link :to="{name: 'dashboard'}" exact class="title text-uppercase mr-3 home-nav">
                <span class="pr-1 font-weight-light">CARU</span>
                <template v-if="$store.state.tenant.config">
                    <v-icon>alternate_email</v-icon>
                    <span class="pl-1">{{$store.state.tenant.config.name}}</span>
                </template>
            </router-link>
            <v-toolbar-items v-if="$store.state.auth.user" class="hidden-sm-and-down">
                <v-btn flat :to="{name: 'dashboard'}" exact>Übersicht</v-btn>
                <v-btn flat :to="{name: 'carecall'}" exact>Pflegerufe</v-btn>
                <v-btn flat :to="{name: 'voicemessage'}" exact>Sprachnachrichten</v-btn>
                <v-btn v-if="$store.state.auth.isAdmin" flat :to="{name: 'admin'}" exact>Admin</v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn :to="{name: 'help'}" flat v-if="$store.state.auth.user">
                Support
                <v-icon right>contact_support</v-icon>
            </v-btn>
            <v-menu bottom left v-if="$store.state.auth.user">
                <v-btn slot="activator" icon>
                    <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                    <v-list-tile :to="{name: 'dashboard'}" class="hidden-md-and-up">
                        <v-list-tile-title>Übersicht</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile :to="{name: 'carecall'}" class="hidden-md-and-up">
                        <v-list-tile-title>Pflegerufe</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile :to="{name: 'voicemessage'}" class="hidden-md-and-up">
                        <v-list-tile-title>Sprachnachrichten</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="$store.state.auth.isAdmin" :to="{name: 'admin'}" class="hidden-md-and-up">
                        <v-list-tile-title>Admin</v-list-tile-title>
                    </v-list-tile>
                    <v-divider class="hidden-md-and-up"></v-divider>
                    <v-list-tile @click="logout">
                        <v-list-tile-title>Abmelden</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-content :class="dark">
            <div style="height: 7px">
                <v-progress-linear v-show="viewLoading" class="ma-0" height="7" color="amber"
                                   :indeterminate="true"></v-progress-linear>
            </div>
            <router-view class="child-view"/>
        </v-content>
        <v-footer class="pa-3 cfooter">
            <div>&copy; {{ new Date().getFullYear() }} CARU AG</div>
        </v-footer>
        <v-snackbar v-model="snackBar.show" color="success" top :timeout="4000">
            {{snackBar.text}}
            <v-btn dark flat @click="snackBarClose">
                {{snackBar.closeText || 'Schliessen'}}
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import { createNamespacedHelpers } from 'vuex'
import { resetStore } from './store'

import './styles/main.scss'

const {mapState, mapMutations} = createNamespacedHelpers('core')

export default {
  name: 'App',
  methods: {
    async logout () {
      (await Auth.currentAuthenticatedUser()).clearCachedTokens()
      await Auth.signOut()
      // Reset any Amplify config.
      Amplify._config = {}
      this.$store.dispatch('tenant/clearConfig')
      this.$router.push({name: 'auth_SignIn'})
      resetStore()
    },
    ...mapMutations(['snackBarClose'])
  },
  computed: {
    dark () {
      return this.$route.meta
    },
    ...mapState(['viewLoading', 'snackBar'])
  }
}
</script>

<style lang="scss">
    .home-nav {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.87);
    }

    .v-content.dark {
        background-color: #D6D1C4;
    }

    .child-view {
        padding-top: 24px - 7px;
    }

    .cfooter {
        background-color: #e9e8e4 !important;
        border-top: 1px solid #bfbbae;
    }
</style>
